module.exports = __webpack_public_path__ + "static/media/our-team.387230e8.png";